import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { keyBy } from "lodash";

import Graph_QL, { DynamicDataObk } from "../..";
import { TerminalTypesInfo } from "../GQLCalls/getTerminalTypesCall";


export type TerminalTypeItem = DynamicDataObk<TerminalTypesInfo[]>

const terminalsDataAdapter = createEntityAdapter({
  selectId: (item: TerminalTypeItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<TerminalTypeItem, string>, {con, data}: TerminalTypeItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const dataDictionary = keyBy(state.entities[identifier].data, "terminal_type_id")
    data.forEach((entry) => dataDictionary[entry.terminal_type_id] = entry)
    const newPayload = {con, data: Object.values(dataDictionary)}
    terminalsDataAdapter.upsertOne(state, newPayload);
  } else { terminalsDataAdapter.addOne(state, {con, data})}
}

const terminalTypesSlice = createSlice({
  name: "terminalTypes",
    initialState: terminalsDataAdapter.getInitialState<TerminalTypeItem[]>([]),
      reducers: {
        maintained: (state, {payload}:PayloadAction<TerminalTypeItem>) => {
          mergePayloadAndState(state, payload);
        }
    }
})

export const TerminalTypesActions = terminalTypesSlice.actions;
export default terminalTypesSlice.reducer;